import { z } from 'zod';
import { endpoint } from './endpoint.js';
import { OfferIdSchema } from '../schemas/offer.js';
import { OfferUnitIdSchema } from '../schemas/offer-unit.js';
import {
  OfferAvailabilityListQuerySchema,
  OfferAvailabilityResponseSchema,
  ReplaceUnitDatesRequestSchema,
} from '../schemas/offer-availability.js';

export const offerAvailability = {
  /**
   * GET /offers/:offerId/availability
   * OPTIONALLY cursor-paginated (`cursor`/`pageSize` query params). When
   * omitted, returns the full unpaginated matrix — required for
   * getPublicLinkAvailability()'s internal callers (public offer link,
   * offer-versions), which never pass pagination params.
   * Auth: effective view.
   */
  getAvailability: endpoint(
    'GET',
    '/offers/:offerId/availability',
    z.object({ offerId: OfferIdSchema }).merge(OfferAvailabilityListQuerySchema),
    OfferAvailabilityResponseSchema,
  ),
  replaceUnitDates: endpoint(
    'PUT',
    '/offers/:offerId/units/:unitId/dates',
    z
      .object({
        offerId: OfferIdSchema,
        unitId: OfferUnitIdSchema,
      })
      .merge(ReplaceUnitDatesRequestSchema),
    z.void(),
  ),
};
